import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row p-2" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row p-2 text-left" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = { class: "col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, [
            _createTextVNode(_toDisplayString(this.store.state.serviceMeta.name) + " - ", 1),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.stateClass)
            }, _toDisplayString(_ctx.state), 3)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, " Namespace: " + _toDisplayString(this.store.state.serviceMeta.namespace), 1),
        _createElementVNode("div", _hoisted_7, " Deployment: " + _toDisplayString(this.store.state.serviceMeta.deployment), 1),
        _createElementVNode("div", _hoisted_8, " ReplicaSet: " + _toDisplayString(this.store.state.serviceMeta.replicaSet), 1),
        _createElementVNode("div", _hoisted_9, " Pod: " + _toDisplayString(this.store.state.serviceMeta.pod), 1)
      ])
    ])
  ]))
}